/**
 * Mock implementation of Node.js path module for browser environment
 * This module proxies to path-browserify to provide the majority of
 * Node's path API, which many bundler plugins rely on. We still expose
 * an object shape close to the native module so consumers expecting
 * additional utilities (posix/win32/normalize/relative/etc) continue
 * to work.
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore path-browserify ships commonjs, rely on Vite/TS transpilation
import pathBrowserify from 'path-browserify';

const pathLib: typeof import('path') = pathBrowserify;

export const basename = pathLib.basename.bind(pathLib);
export const dirname = pathLib.dirname.bind(pathLib);
export const extname = pathLib.extname.bind(pathLib);
export const format = pathLib.format?.bind(pathLib) ?? ((options: any) => pathLib.format(options));
export const isAbsolute = pathLib.isAbsolute.bind(pathLib);
export const join = pathLib.join.bind(pathLib);
export const normalize = pathLib.normalize.bind(pathLib);
export const parse = pathLib.parse.bind(pathLib);
export const relative = pathLib.relative.bind(pathLib);
export const resolve = pathLib.resolve.bind(pathLib);
export const sep = pathLib.sep;
export const delimiter = (pathLib as any).delimiter ?? ':';
export const posix = pathLib.posix ?? pathLib;
export const win32 = pathLib.win32 ?? pathLib;
export const toNamespacedPath = (pathLib as any).toNamespacedPath ?? ((value: string) => value);

export default {
  basename,
  dirname,
  extname,
  format,
  isAbsolute,
  join,
  normalize,
  parse,
  posix,
  relative,
  resolve,
  sep,
  delimiter,
  toNamespacedPath,
  win32,
};
